import React, { useState } from 'react';
import { bool, func, shape } from 'prop-types';
import { useMutation } from '@apollo/client';
import { captureException } from '@playbookux/playbook-web-core';
import * as S from './styles';
import { UPDATE_OPTION_RATING_PERCENTAGE, UPDATE_SCREENER_RATING_PERCENTAGE } from '../../graphql';

function EditNumberDialog(props) {
  const {
    onClose, open, audienceChange, onRefetch,
  } = props;
  const [ratting, setRatting] = useState(audienceChange.ratingPercentage.replace('%', ''));

  const [updateScreenerRatingPercentage, { loading }] = useMutation(UPDATE_SCREENER_RATING_PERCENTAGE, {
    onCompleted: async () => {
      onClose();
      await onRefetch();
    },
  });

  const [updateOptionRatingPercentage, { loading: loadingOption }] = useMutation(UPDATE_OPTION_RATING_PERCENTAGE, {
    onCompleted: async () => {
      onClose();
      await onRefetch();
    },
  });

  const handleSave = async () => {
    try {
      switch (audienceChange.typeUpdate) {
        case 'question':
          await updateScreenerRatingPercentage({
            variables: {
              questionId: audienceChange.id,
              screenerRatingPercentage: parseFloat(ratting),
            },
          });
          break;
        case 'questionOption':
          await updateOptionRatingPercentage({
            variables: {
              questionOptionId: audienceChange.id,
              optionRatingPercentage: parseFloat(ratting),
            },
          });
          break;
        default:
          break;
      }
      onClose();
    } catch (error) {
      captureException('UPDATE_PERCENTAGE_FAILED', error);
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setRatting(value);
  };

  return (
    <S.Modal
      onClose={onClose}
      open={open}
    >
      <S.ModalHeader>
        <S.Title>
          Edit Number
        </S.Title>
      </S.ModalHeader>
      <S.Container>
        <S.InputContainer>
          <S.Input value={ratting} onChange={handleChange} />
          %
        </S.InputContainer>

        <S.ContainerBottom>
          <S.ButtonSave
            loading={loading || loadingOption}
            disabled={loading || loadingOption}
            onClick={handleSave}
          >
            Save
          </S.ButtonSave>
        </S.ContainerBottom>
      </S.Container>
    </S.Modal>
  );
}

EditNumberDialog.propTypes = {
  onClose: func.isRequired,
  open: bool.isRequired,
  audienceChange: shape().isRequired,
  onRefetch: func.isRequired,
};

export default EditNumberDialog;
